module.exports = "dist/images/components-design-separator-control-rounded-3.54719e2.png";